import React from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';
import avo from 'analytics/avo';

import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_CATEGORY_TOP_SALES_PRODUCTS } from 'mocks/queries';
import ProductCardCarousel from './index';

const CategoryBestSellersCarousel = ({ categoryId }) => {
  const { loading, data } = useSuspenseQuery(GET_CATEGORY_TOP_SALES_PRODUCTS, {
    variables: { id: categoryId },
    fetchPolicy: 'cache-and-network',
  });

  if (!categoryId) {
    return null;
  }

  if (
    !loading &&
    data?.getCategoryTopSalesProducts &&
    data.getCategoryTopSalesProducts.length > 0
  ) {
    const sortedCategoryTopSales = sortBy(data.getCategoryTopSalesProducts, [
      'position',
    ]);

    const productIds = sortedCategoryTopSales.map(
      product => product.product_id
    );

    return (
      <ProductCardCarousel
        analyticsComponentName={avo.Component.BEST_SELLERS_CAROUSEL}
        ids={productIds}
        idType="id"
        title="Best Sellers"
      />
    );
  }

  return null;
};

CategoryBestSellersCarousel.propTypes = {
  categoryId: PropTypes.number,
};
export default CategoryBestSellersCarousel;
